export default function clientCertificateSpkiHash(value: string): string {
  try {
    if (atob(value)?.length === 32) {
      return "";
    }
  } catch {
    // ignore
  }
  return "Improper format for Spki Hash!";
}
